import { Action } from '../action';
import { AuthType } from '../Auth/action';
import { ModificationLoanFormState } from './state';
import { ModificationLoanFormType } from './action';
import { FilterType } from '../Filter/action';

export const initialState: ModificationLoanFormState = {
    loanForms: [],
};

export const modificationLoanFormReducer = (
    state: ModificationLoanFormState | undefined,
    action: Action,
): ModificationLoanFormState => {
    state = state ?? initialState;

    switch (action.type) {
        case ModificationLoanFormType.LoanFormsLoaded:
            return { ...state, loanForms: action.loanForms };
        case FilterType.filterResetRequest:
        case AuthType.TokenExpired:
            return initialState;
        default:
            return state;
    }
};
